/* eslint-disable @typescript-eslint/no-unused-vars */
// @ts-nocheck
// Only disabling while in the process of refactoring.
import { useEffect, useState } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { PaymentOrigin } from '@frontend/api-invoices';
import appConfig from '@frontend/env';
import { useFetch } from '@frontend/fetch';
import {
  useLocationPortal,
  FailureHandler,
  SuccessHandler,
  useSetupPaymentIntent,
  LocationInformation,
  PortalDisabledTypes,
} from '@frontend/payments-portal';
import {
  PaymentConfigName,
  usePaymentMethodConfig,
  stripeAppearance as appearance,
  useStripePromise,
} from '@frontend/payments-stripe-wrapper';
import { ContentLoader } from '@frontend/design-system';
import { PortalDisabledPage } from './weave-bill-pay-disabled-page';

const { PAY_BACKEND_API } = appConfig;

interface WeaveBillPayProps {
  locationSlug: string;
  amount?: number;
  amountEditable?: boolean;
  showLocationInfo?: boolean;
  paymentConfigName?: PaymentConfigName;
  originType?: PaymentOrigin;
  captchaToken?: string | null;
  onSuccess?: SuccessHandler;
  onFailure?: FailureHandler;
}

export const WeaveBillPay = ({
  locationSlug,
  amount,
  amountEditable = true,
  showLocationInfo = true,
  paymentConfigName,
  originType = PaymentOrigin.OnlineBillPay,
  captchaToken = null,
  onSuccess,
  onFailure,
}: WeaveBillPayProps) => {
  const { setLocationIdHeader } = useFetch();
  const { stripePromise } = useStripePromise();
  const paymentMethodConfiguration = usePaymentMethodConfig({ paymentConfigName });
  const { portalData } = useLocationPortal({ locationSlug, onFailure });
  const [isEnabled, setIsEnabled] = useState(true);

  const { getPaymentIntent } = useSetupPaymentIntent({
    url: `${PAY_BACKEND_API}/payments/v2/portal/${portalData?.id}/payments`,
    onFailure,
  });

  useEffect(() => {
    setLocationIdHeader(portalData?.id);
  }, []);

  useEffect(() => {
    if (portalData?.onlineBillPayEnabled) {
      setIsEnabled(true);
    } else {
      setIsEnabled(false);
    }
  }, [portalData?.onlineBillPayEnabled]);

  if (!portalData?.onBehalfOf) return <ContentLoader show={true} />;

  return isEnabled ? (
    <Elements
      stripe={stripePromise || null}
      options={{
        mode: 'payment',
        amount: 50,
        currency: 'usd',
        setupFutureUsage: undefined,
        appearance,
        onBehalfOf: portalData.onBehalfOf,
        paymentMethodConfiguration,
        paymentMethodOptions: {
          us_bank_account: {
            financial_connections: {
              permissions: ['payment_method', 'balances'],
            },
          },
        },
      }}
    >
      <LocationInformation
        locationData={{
          name: portalData?.name,
          email: portalData?.email,
          phoneNumber: portalData?.phoneNumber,
          logo: portalData?.locationLogo,
        }}
      />
      {/* 
        Need to pass/handle the following with the built components
        -   amount,
        -   amountEditable = true,
        -   showLocationInfo = true,
        -   originType = PaymentOrigin.OnlineBillPay,
        -   captchaToken = null,
        -   onSuccess,
      */}
    </Elements>
  ) : (
    <PortalDisabledPage
      locationSlug={locationSlug}
      reason={!portalData.onlineBillPayEnabled ? PortalDisabledTypes.Disabled : PortalDisabledTypes.RateLimit}
    />
  );
};

export default WeaveBillPay;
